import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { AppConfig } from '../../config/app.config';

@Pipe({
  name: 'currencyFormatter'
})
export class CurrencyFormatterPipe extends DecimalPipe implements PipeTransform {
  env: any;
  constructor(appConfig: AppConfig){
    super('en-US');
    this.env = appConfig.getEnv();
  }
  transform(value: any, ...args: string[]): any {
    const format = this.env.format.currency[args[0]] ?? '1.0-2';
    return super.transform(value, format);
  }

}
